import { type DescriptionsProps } from 'antd';

type DescriptionItems = NonNullable<DescriptionsProps['items']>;

/**
 * Genera items di tipo Descriptions a partire da un array di
 * coppie [label, valore]. Le coppie con valore nullo/vuoto
 * vengono automaticamente escluse.
 */
export function getItemsFromEntries(
  entries: [string, string | null | undefined][],
): DescriptionItems | undefined {
  const items: DescriptionItems = [];

  for (const [label, value] of entries) {
    if (value) {
      items.push({ label, children: value });
    }
  }

  return items.length > 0 ? items : undefined;
}

export function joinName(
  first?: string | null,
  last?: string | null,
): string | undefined {
  const full = [first, last].filter(Boolean).join(' ');
  return full || undefined;
}
